module.exports = __webpack_public_path__ + "img/light.724d0120.png";